import { Reveal } from "./Reveal";
import { AREAS, COMPLIANCE } from "../../data/site";
import { MapPin } from "lucide-react";

export default function Coverage() {
  return (
    <section data-testid="coverage-section" className="relative py-24 bg-coral overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-5">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/70">/ Área de atuação</span>
          <h2 className="mt-4 font-display font-extrabold tracking-tighter text-white text-4xl sm:text-5xl leading-[0.95]">
            Presentes em toda a Baixada Santista.
          </h2>
          <p className="mt-5 text-white/85 text-lg leading-relaxed max-w-md">
            Agilidade e proximidade para atender seu condomínio com rapidez, sempre que precisar.
          </p>
        </Reveal>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/20 border border-white/20">
            {AREAS.map((a, i) => (
              <Reveal key={a} delay={i * 0.05} className="bg-coral p-6 flex items-center gap-3">
                <MapPin size={18} className="text-white" />
                <span className="font-display font-bold text-white text-xl">{a}</span>
              </Reveal>
            ))}
          </div>
          <div className="mt-6 flex flex-wrap gap-2">
            {COMPLIANCE.map((c) => (
              <span key={c} className="font-mono text-xs text-white border border-white/40 px-3 py-1.5">{c}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
